import { useState } from "react";
import { Row, Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ConfirmationSection from "../cards/Confirmation";
import B2BFeed from "../cards/B2BFeed";
import moment from "moment";
import { useAppSelector } from "../../../redux/hooks";
import TrellisNavLink from "../../../components/core/basic/NavLink";

interface PriceLogProps {
  tabList?: string[];
  vertical?: boolean;
}

const PriceLog = ({
  tabList = ["price_increases", "price_decreases", "price_mismatch", "b2b_changes"],
  vertical = false,
}: PriceLogProps) => {
  const { t } = useTranslation(["pricingv2"]);
  const marketPlace = useAppSelector((state) => state.marketPlace);
  const [tab, setTab] = useState("price_increases");

  const now = moment();

  return (
    <Row>
      <Col className="pt-3" xs={vertical ? 2 : 12}>
        <Nav
          variant="underline"
          onSelect={(k) => {
            if (k) {
              setTab(k);
            }
          }}
          activeKey={tab}
          className={vertical ? `flex-column text-start` : undefined}
          style={{ borderRight: vertical ? "1px solid #E0E0E0" : undefined }}
        >
          {tabList.includes("price_increases") && (
            <TrellisNavLink eventKey="price_increases" className="text-start">
              <span className="fs-4">{t(($) => $.pricingv2["Price Uplift"])}</span>
            </TrellisNavLink>
          )}

          {tabList.includes("price_decreases") && (
            <TrellisNavLink eventKey="price_decreases" className="text-start">
              <span className="fs-4">{t(($) => $.pricingv2["Price Reduction"])}</span>
            </TrellisNavLink>
          )}
          {tabList.includes("price_mismatch") && (
            <TrellisNavLink eventKey="price_mismatch" className="text-start">
              <span className="fs-4">{t(($) => $.pricingv2["Price Mismatch"])}</span>
            </TrellisNavLink>
          )}
          {tabList.includes("b2b_changes") && (
            <TrellisNavLink eventKey="b2b_changes" className="text-start">
              <span className="fs-4">{t(($) => $.pricingv2["B2B Price Changes"])}</span>
            </TrellisNavLink>
          )}
        </Nav>
      </Col>
      {tab === "price_increases" && (
        <Col className="pt-3" xs={vertical ? 10 : 12}>
          <ConfirmationSection
            limit={100}
            marketPlace={marketPlace}
            date={now}
            priceDiff={"INCREASE"}
            usePricingPlan={true}
            pricingProduct={null}
            pricingPlan={null}
          />
        </Col>
      )}

      {tab === "price_decreases" && (
        <Col className="pt-3" xs={vertical ? 10 : 12}>
          <ConfirmationSection
            limit={100}
            marketPlace={marketPlace}
            date={now}
            priceDiff={"DECREASE"}
            usePricingPlan={true}
            pricingProduct={null}
            pricingPlan={null}
          />
        </Col>
      )}

      {tab === "price_mismatch" && (
        <Col className="pt-3" xs={vertical ? 10 : 12}>
          <ConfirmationSection
            limit={100}
            marketPlace={marketPlace}
            date={now}
            priceMismatch={true}
            usePricingPlan={true}
            pricingProduct={null}
            pricingPlan={null}
          />
        </Col>
      )}

      {tab === "b2b_changes" && (
        <Col className="pt-3" xs={vertical ? 10 : 12}>
          <B2BFeed marketPlace={marketPlace} />
        </Col>
      )}
    </Row>
  );
};

export default PriceLog;
